import { SxProps, Theme } from '@mui/material'
import { tooltipClasses } from '@mui/material/Tooltip'
import {
  AISLE_ACTIVE_ACCENT,
  BORDER_SUBTLE,
  GRID_ROW_ACTIVE_BG,
  GRID_ROW_BASE_BG,
  GRID_ROW_HOVER_BG,
  SURFACE_MUTED,
  WHITE,
} from '../config/constants'

/** Estilos propios de la grilla principal. Lo compartido vive en `shared.styles`. */
export const layoutGridStyles = {
  root: { display: 'flex' } as SxProps<Theme>,

  /**
   * El contenedor scrolleable hace doble función: es el área de paneo y el
   * ámbito del resumen (los clicks fuera de sus celdas lo cierran).
   *
   * `maxHeight` se calcula hasta el fondo del viewport para evitar el scroll de
   * la ventana completa sin depender de una estimación del chrome de arriba.
   */
  scrollArea: (isDragging: boolean, maxHeight: number | null): SxProps<Theme> => ({
    overflow: 'auto',
    cursor: isDragging ? 'grabbing' : 'grab',
    userSelect: 'none',
    maxHeight: maxHeight ?? undefined,
    border: `1px solid ${BORDER_SUBTLE}`,
    borderRadius: 1,
    bgcolor: SURFACE_MUTED,
  }),

  grid: (templateColumns: string): SxProps<Theme> => ({
    display: 'inline-grid',
    gridTemplateColumns: templateColumns,
    gap: '3px',
    p: 1,
    minWidth: 'max-content',
  }),

  /**
   * MUI separa el tooltip 14px con un selector descendente:
   * `.MuiTooltip-popper[data-popper-placement*="right"] &`. Un `sx` plano sobre
   * el tooltip pierde por especificidad (0,1,0 contra 0,3,0), así que hay que
   * replicar la misma forma de selector para poder ganarle.
   */
  aisleTooltipPopper: {
    [`&[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]: {
      marginLeft: '4px',
    },
  } as SxProps<Theme>,

  /** Chip de pasillo: relleno azul porque, a diferencia del nivel, sí es clickeable. */
  aisleChip: (isActive: boolean, size: number): SxProps<Theme> => ({
    position: 'sticky',
    left: 0,
    zIndex: 10,
    bgcolor: isActive ? GRID_ROW_ACTIVE_BG : GRID_ROW_BASE_BG,
    borderLeft: isActive ? `3px solid ${AISLE_ACTIVE_ACCENT}` : 'none',
    borderRadius: '3px',
    height: size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    '&:hover': { bgcolor: isActive ? GRID_ROW_ACTIVE_BG : GRID_ROW_HOVER_BG },
  }),

  aisleChipText: { color: WHITE } as SxProps<Theme>,
}
